import { useQuery, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import axiosInstance from "../../services/axiosInstance";

async function getSearch(searchTerm, searchType, filters) {
  const instance = axiosInstance();
  const response = await instance.post(`/search-${searchType}/`, {
    term: searchTerm,
    filters, 
  });
  return response.data;
}
export function useSearch({ searchTerm, searchType, filters }) {
  const queryClient = useQueryClient();
  const queryKey = [`search-${searchType}`, searchTerm, filters];
  // Truncate the searchTerm if it exceeds 8000 characters
  const truncatedSearchTerm =
    searchTerm?.length > 8000 ? searchTerm?.substring(0, 8000) : searchTerm;
  return useQuery({
    queryKey: queryKey,
    queryFn: async () => {
      if (truncatedSearchTerm?.trim() === "") return null;
      return getSearch(truncatedSearchTerm, searchType || "federal", filters);
    },
    onSuccess: () => {
      queryClient.invalidateQueries(["leads"]);
    },
    onError: (e) => {
      if (e.response?.data?.detail) toast.error(e.response.data?.detail);
      else toast.error(e.message);
    },
  });
}
